module.exports = __webpack_public_path__ + "static/tim-064914f79e1361cfe045f0045e9b03a2.jpg";